"use strict";

var _trimInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/trim");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.ungarble = exports.stripMarkup = exports.semantify = exports.plainText = exports.isSimilarSubstring = exports.depressify = exports.cleanMarkup = exports.cleanInput = void 0;
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/index-of"));
var _memoizee = _interopRequireDefault(require("memoizee"));
var _markup = require("@raywhite/markup");
var _string = require("./string");
/**
 * Office and agent descriptions are (presently) allowed to
 * contain certain HTML tags, this function enforces this.
 * Memoized for prudence.
 *
 * @param {String} - the string to be stripped of HTML tags
 * @return {Object} - the cleaned string wrapped for react
 */
var cleanMarkup = exports.cleanMarkup = (0, _memoizee.default)(dirty => ({
  __html: (0, _markup.cleanup)(dirty)
}), {
  max: 100,
  primitive: true
});

/**
 * Office and agent testimonials are not supposed to contain
 * markup, this function will strip it from a block of text.
 * Memoized for prudence ;).
 *
 * @param {String} - the string to be stripped of HTML tags
 * @return {Object} - sanitized string wrapped for react
 */
var stripMarkup = exports.stripMarkup = (0, _memoizee.default)(unsafe => ({
  __html: (0, _markup.strip)(unsafe, false)
}), {
  max: 100,
  primitive: true
});

/**
 * Listing descriptions can contain only breaks, but double breaks
 * are frequently used to simulate paragraphs. This function takes
 * a listing description and replaces double breaks with semantically
 * correct paragraphs. Where applicable, unordered lists will be
 * generated in place of a pragraph. Single breaks are preserved. Memoized.
 *
 * @param {String} - the string containing breaks
 * @return {Object} - the paragraphified string wrapped for react
 */
var semantify = exports.semantify = (0, _memoizee.default)(markup => ({
  __html: (0, _markup.paragraph)(markup)
}), {
  max: 100,
  primitive: true
});

/**
 * @param {String} - the string to be ungarbled and semantified
 * @return {Object} - sanitized string wrapped for reac
 */
var ungarble = exports.ungarble = (0, _memoizee.default)(markup => ({
  __html: (0, _markup.unparagraph)(markup)
}), {
  max: 100,
  primitive: true
});
var isSimilarSubstring = exports.isSimilarSubstring = function close() {
  var NOT_CHAR = /[^A-Z\d]/g;
  var HTML_ENTITY = /&(#[0-9]+|[A-Z]+);/g;
  var fingerprint = str => (0, _markup.strip)(str).toUpperCase().replace(HTML_ENTITY, '').replace(NOT_CHAR, '');

  /**
   * Normalises two strings, and checks if one (or something similar)
   * exists inside the other (or something similar). Note that since
   * this is being used to compare mangled markup with non-mangled
   * markup, we also strip HTML tags.
   *
   * @param {String}
   * @param {String}
   * @return {Boolean}
   */

  return (0, _memoizee.default)((str, _str) => {
    var _context;
    return (0, _indexOf.default)(_context = fingerprint(str)).call(_context, fingerprint(_str)) !== -1;
  }, {
    max: 100,
    primative: true
  });
}();

/**
 * Takes a listing description (containing only breaks) and transforms
 * it to produce a set of semantically correct paragraphs, and

/**
 * Custom content generated serialized by wordpress contains inline styles
 * that we don't need and also contains markup which is difficult or impossible
 * to target in CSS. This functions removes unnecessary attributes and
 * adds classes as required for targetting. Memoized.
 *
 * @param {String} - wordpress generated markup
 * @return {Object} - depressified markup wrapped for react
 */
var depressify = exports.depressify = (0, _memoizee.default)(markup => ({
  __html: (0, _markup.depress)(markup)
}), {
  max: 100,
  primitive: true
});

/**
 * Standard input sanitisation; removes markup and trailing/leading whitespace.
 *
 * @param {String} s The string to clean.
 * @return {String} A cleaned string.
 */
var cleanInput = s => s && (0, _trimInstanceProperty(_string))((0, _markup.strip)(s, false));

/**
 * Attempts to conver the given content to plain text by removing markup and
 * some HTML entities.  Unknown HTML entities are simply replaced by white space,
 * which is not always the best, but avoids needing something that knows how to
 * correctly convert all of them.
 */
exports.cleanInput = cleanInput;
var plainText = content => (0, _markup.strip)(content, true);
exports.plainText = plainText;